import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-ty-testimonials',
  templateUrl: './ty-testimonials.component.html',
  styleUrls: ['./ty-testimonials.component.scss']
})
export class TyTestimonialsComponent implements OnInit {

  @Input() heading;
  @Input() subheading;
  @Input() cards = [
    {
      content: `For a while, I had been trying to find a credible site to contribute to.
      When I stumbled upon Ketto’s Monthly Giving Program, I was thrilled.
      I signed up & the experience has been great.
      I know exactly where my contributions are going & I
      receive regular updates about the kids I supported.
      I feel like I am making a difference.`,
      donor: 'Suraj',
      country: '',
      image: ''
    },
    {
      content: `I give Rs 1000 every month. Every time I go out, or have dinner,
      I spend much more. So I thought if I can set aside a little amount
      which can help someone buy medicines or get life-saving surgery,
      I should not think twice. And when I hear recovery stories,
      when I see how well they are doing, it fills my heart with utmost joy!`,
      donor: 'Nitya',
      country: ''
    },
    {
      content: `I might not be able to save someone alone, but when I see so many people coming together,
      it gives me so much hope. Every bit counts, every bit is giving someone
      a chance to lead a better life. There’s no better feeling than being a
      part of someone’s recovery journey.`,
      donor: 'Shubham',
      country: ''
    }
  ];

  breakpoints = {
    600: {
      perView: 1,
      startAt: 1,
      focusAt: 'center',
      gap: 10
    },
    1200: {
      perView: 3,
      gap: 20
    }
  };
  constructor() { }

  ngOnInit() {
  }

}
